(function () {
    'use strict';

    angular
        .module('app.helpText')
        .controller('HelpTextDetailController', HelpTextDetailController);

    HelpTextDetailController.$inject = [
        '$state', '$stateParams',
        'bootstrap.dialog', 'common', 'dataservice', '$sce', '$templateRequest', 'helpTextFactory'
    ];

    function HelpTextDetailController($state, $stateParams,
        bsDialog, common, dataservice, $sce, $templateRequest, helpTextFactory) {
        /*jshint validthis: true */
        var vm = this;
        var logger = common.logger;
        var $q = common.$q;
        vm.cancel = cancel;
        vm.deleteItem = deleteItem;
        vm.isSaving = false;
        vm.save = save;
        vm.filters = undefined;
        vm.preventDelete = preventDelete;
        vm.states = [];
        vm.fields = [];
        vm.helpTextData = [];
        vm.stateChange = stateChange;
        vm.isLoading = true;
        activate();

        function activate() {
            var promises = [common.checkIsAdmin(), initLookups(), getItem(), loadHelpTextData()];
            return common.$q.all(promises).then(function (data) {
                stateChange();
                vm.isLoading = false;
            }, function (error) { });
        }

        function loadHelpTextData() {
            return helpTextFactory.helpTextData(true).then(function (data) {
                vm.helpTextData = data;
            }, function (error) { });
        }

        function cancel() {
            backToList();
        }

        function backToList() {
            $state.go("helptext.list");
        }

        function preventDelete() {
            if ( $stateParams.id === '') {
                return true;
            }
            return false;
        }

        function stateChange() {
            if (!vm.isLoading) {
                vm.item.Question = '';
                vm.item.FieldName = '';
            }
            var s = null;
            for (var i = 0; i < vm.states.length; i++) {
                if (vm.states[i].name === vm.item.State) {
                    s = vm.states[i];
                    break;
                }
            }
            if (s != null) {
                vm.fields = [];
                var stateName = s.name;
                if (stateName === 'opsconfig') {
                    vm.fields = [];
                    dataservice.getItem("api/OpsConfig/")
                        .then(function (response) {
                            var configOptions = response.data;
                            for (var i = 0; i < configOptions.length; i++) {
                                _addFieldIfDoesntExist(stateName, configOptions[i].SettingKey);
                            }
                        }, function (error) { });
                    vm.fields.sort();
                }
                else if (stateName === 'book') {
                    _addFieldIfDoesntExist(stateName, 'bookHelpPopover');
                }
                else if (stateName === 'dailysetup') {
                    _processTemplate('app/layout/_filters.html', stateName);
                }
                else {
                    _processTemplate(s.templateUrl, stateName);
                    if (stateName === 'users.details') {
                        _processTemplate('app/users/_coreDetails.html', stateName);
                    }
                    if (stateName === 'tasks.details') {
                        _processTemplate('app/tasks/_details.html', stateName);
                    }
                }
            }
        }

        function _processTemplate(templateUrl, stateName) {
            
            $templateRequest(templateUrl).then(function (template) {
                var div = document.createElement("div");
                var $div = $(div);
                
                $div.html(template);
                
                $div.find("label").each(function () {
                    var forAttr = $(this).attr("for");
                    if (forAttr) {
                        _addFieldIfDoesntExist(stateName, forAttr);
                    }
                });
                $div.find("sp-checkbox-list").each(function () {
                    var forAttr = $(this).attr("help-text-field");
                    if (forAttr) {
                        _addFieldIfDoesntExist(stateName, forAttr);
                    }
                });

                $div.find("div[help-text-field]").each(function () {
                    var fieldAttr = $(this).attr("help-text-field");
                    if (fieldAttr) {
                        _addFieldIfDoesntExist(stateName, fieldAttr);
                    }
                });

                vm.fields.sort();
                

            }, function () { })
        }


        function _addFieldIfDoesntExist(stateName, fieldName) {
            if ($stateParams.id === '') {
                for (var i = 0; i < vm.helpTextData.length; i++) {
                    var d = vm.helpTextData[i];
                    if (d.State === stateName && fieldName === d.FieldName) {
                        return;
                    }
                }
            }

            vm.fields.push(fieldName);
        }

        function deleteItem() {
            return bsDialog.deleteDialog('Help Text')
                .then(confirmDelete, function () { });

            function confirmDelete() {
                dataservice.deleteItem("api/HelpText/" + vm.item.ID).then(success).catch(failed);

                function success() {
                    backToList();
                }

                function failed(error) {
                    logger.error(error);
                }
            }
        }

        function getItem() {
            var val = $stateParams.id;
            if (val === '') {
                vm.item = {};
                common.setAuditInfo(vm.item);
                return vm.item;
            }

            return dataservice.getItem("api/HelpText/" + val)
                .then(function (response) {
                    if (response) {
                        vm.item = response.data;
                        common.setAuditInfo(vm.item);
                        common.convertDateStringsToDates(vm.item);
                        
                    } else {
                        logger.warning('Could not find item with id = ' + val);
                        $state.go('404');
                    }
                })
                .catch(function (error) {
                 //   logger.error('Error while getting item with id = ' + val + '; ' + error);
                 //   $state.go('404');
                });
        }
        function initLookups() {
            var states = $state.get();
            for (var i = 0; i < states.length; i++) {
                var s = states[i];
                if (!s.abstract) {
                    vm.states.push(s);
                }
            }

            vm.states.sort(function (a, b) {
                if (a.name < b.name) {
                    return -1;
                }
                if (a.name > b.name) {
                    return 1;
                }
                return 0;
            });
        }

        function save() {
            vm.isSaving = true;
            dataservice.saveItem('api/HelpText/Save', vm.item).then(function (saveResult) {
                vm.isSaving = false;
                helpTextFactory.helpTextData(true).then(function (data) {
                    vm.helpTextData = data;
                }, function (error) { });
                backToList();
            }).catch(function (error) {
                vm.isSaving = false;
            });
        }
    }
})();
